/**
 * AvatarIcon component displays a fruit illustration avatar for user accounts.
 * Shows different illustrations based on brand (Misfits Market vs Imperfect Foods)
 * and can display special anniversary versions for one year club members.
 *
 * @param {Object} props - Component props
 * @param {boolean} [props.isMisfits=true] - Whether to show Misfits Market branding
 * @param {boolean} [props.oneYearClub] - Whether to show the one year anniversary version
 * @param {number} [props.width=90] - Width of the avatar icon in pixels
 * @returns {JSX.Element} An img element with the appropriate avatar illustration
 */

function AvatarIcon({ isMisfits, oneYearClub, width }) {
    return isMisfits ? (
        <img
            alt="Misfits Market's fruit illustration"
            aria-hidden="true"
            src={
                oneYearClub
                    ? 'https://img-cdn.misfitsmarket.com/boysenberry/icons/AvatarMisfits1Year.svg'
                    : 'https://img-cdn.misfitsmarket.com/boysenberry/icons/AvatarMisfits.svg'
            }
            width={width}
        />
    ) : (
        <img
            alt="Imperfect Foods fruit illustration with eyes"
            aria-hidden="true"
            src={
                oneYearClub
                    ? 'https://img-cdn.misfitsmarket.com/boysenberry/icons/AvatarImperfect1Year.svg'
                    : 'https://img-cdn.misfitsmarket.com/boysenberry/icons/AvatarImperfect.svg'
            }
            width={width}
        />
    );
}

export default AvatarIcon;
